// removed by extract-text-webpack-plugin
module.exports = {"marketGroup":"_2LoB7olEy5Js5yEkIVMhWb","marketType":"_1socyfuA-TDrS59pxYyTuO","winningMarginTeamHeader":"dpkUNuj_qEDKWW81XjFIB","scoreGroup":"_3OCAhaCcCYwLTgu-NiuyVW","marketText":"_1BRTrX9EOIyNT8kADsA8eW","oddsButton":"_3PzHW88caPkIOtFHlf0JHR","scoreGroup2ndLevel":"_1UJxez7ARVbIzsPnWD-EKG"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/basketball/css/markets.css
// module id = 159
// module chunks = 0